import React, { useEffect, useState } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import Header from "./Front/Header";
import Footer from "./Front/Footer";
import API_BASE_URL from "../Config";
import { v4 as uuidv4 } from "uuid";
import parse from "html-react-parser";
import DOMPurify from "dompurify";

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Thumbs } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/thumbs";

import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

import { toast } from "react-toastify";

//import "./FrontClinicDetails.css"; // ← separate stylesheet
import "./styles/home.css";
import "../styles/global.css";

/* ── Reusable star-rating component ── */
const StarRow = ({ score = 4.5, count }) => {
  const full = Math.floor(score);
  const half = score % 1 >= 0.5;
  return (
    <div className="clinic-doctor-rating-row">
      <span className="clinic-doctor-stars">
        {[...Array(5)].map((_, i) => (
          <i
            key={i}
            className={
              i < full
                ? "fa-solid fa-star"
                : i === full && half
                  ? "fa-solid fa-star-half-stroke"
                  : "fa-regular fa-star"
            }
          />
        ))}
      </span>
      <span className="clinic-doctor-rating-text">
        {score}/5{count ? ` (${count})` : ""}
      </span>
    </div>
  );
};

const TABS = ["Overview", "Doctors", "Services", "Reviews"];

const FrontClinicDetails = () => {
  /* ── All original state — unchanged ── */
  const [visitType, setVisitType] = useState("In-person");
  const navigate = useNavigate();
  const { slug } = useParams();
  const [clinic, setClinic] = useState(null);
  const [imagesSwip, setImages] = useState(null);
  const [thumbsSwiper, setThumbsSwiper] = useState(null);
  const [activeDate, setActiveDate] = useState("");

  /* ── New UI-only state ── */
  const [activeTab, setActiveTab] = useState("Overview");

  /* ── Fancybox init — unchanged ── */
  useEffect(() => {
    Fancybox.bind('[data-fancybox="gallery"]', {
      Thumbs: { autoStart: true },
      Toolbar: {
        display: {
          left: ["infobar"],
          middle: ["zoomIn", "zoomOut", "toggle1to1", "rotateCCW", "rotateCW", "flipX", "flipY"],
          right: ["slideshow", "thumbs", "close"],
        },
      },
    });
    return () => {
      Fancybox.destroy();
    };
  }, []);

  /* ── API fetch — unchanged ── */
  const fetchClinic = async (slug) => {
    const response = await fetch(`${API_BASE_URL}api/clinic/${slug}`);
    const json = await response.json();
    if (json.status) {
      setClinic(json.data);
      const images = json.data.imageq ? json.data.image.split(",") : [];
      setImages(images);
    }
  };

  /* ── Effects — unchanged ── */
  useEffect(() => {
    fetchClinic(slug);
    const today = new Date().toISOString().split("T")[0];
    setActiveDate(today);
  }, [slug]);

  /* ── Device ID — unchanged ── */
  let deviceId = localStorage.getItem("device_id");
  if (!deviceId) {
    deviceId = uuidv4();
    localStorage.setItem("device_id", deviceId);
  }

  /* ── Derived values ── */
  const heroImage = clinic?.image?.length
    ? `${API_BASE_URL}public/clinic/${clinic.image.split(",")[0]}`
    : `${API_BASE_URL}public/noimage.jpg`;

  return (
    <div className="clinic-page">
      <Header />

      {/* ── Breadcrumb ── */}
      {/* <section className="cl-breadcrumb-bar py-xl-3 py-3">
        <div className="container-fluid">
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb mb-0">
              <li className="breadcrumb-item"><a href="index.html">Home</a></li>
              <li className="breadcrumb-item active" aria-current="page">Clinic List</li>
              <li className="breadcrumb-item active" aria-current="page">{clinic?.name || "Clinic Detail"}</li>
            </ol>
          </nav>
        </div>
      </section> */}
      <section className="cl-breadcrumb-bar py-xl-3 py-3">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb mb-0">
                 <li className="breadcrumb-item">
                    <Link to="/">Home</Link>
                  </li>

                  <li className="breadcrumb-item">
                    <Link to="/clinic-list-page">Clinic List</Link>
                  </li>

                  <li className="breadcrumb-item active" aria-current="page">
                    {clinic?.name || "Clinic Detail"}
                  </li>
                </ol>
              </nav>
            </div>
          </div>
        </div>
      </section>
      {/* ── Hero ── */}
      <div className="clinic-hero">
        <div className="container clinic-hero-inner">
          <div className="clinic-hero-card">

            <img
              src={heroImage}
              alt={clinic?.name || "Clinic"}
              className="clinic-hero-img"
            />

            <div className="clinic-hero-body">
              <span className="clinic-badge-verified">
                <i className="fa-solid fa-circle-check" />
                Verified Clinic
              </span>

              <h1 className="clinic-hero-name">{clinic?.name || "—"}</h1>

              <div className="clinic-hero-meta">
                <span className="clinic-hero-meta-item">
                  <i className="fa-solid fa-location-dot" />
                  {clinic?.address || "Location N/A"}
                </span>
              </div>

              <div className="clinic-hero-rating">
                <span className="clinic-stars-hero">★★★★☆</span>
                <span className="clinic-rating-text-hero">4.5 · 128 reviews</span>
              </div>

              {/* <div className="clinic-hero-cta">
                <button className="clinic-btn-book">
                  <i className="fa-solid fa-calendar-check" />
                  Book Appointment
                </button>
                <button className="clinic-btn-call">
                  <i className="fa-solid fa-phone" />
                  Call Now
                </button>
              </div> */}
              <div className="clinic-hero-cta">
  <a  href={`tel:${clinic?.mobile || ""}`}  className="clinic-btn-call">
    <i className="fa-solid fa-phone" />
    Call Now
  </a>
</div>
            </div>
          </div>
        </div>
      </div>

      {/* ── Tabs Bar ── */}
      <div className="clinic-tabs-bar">
        <div className="container">
          <div className="clinic-tabs-inner">
            {TABS.map((t) => (
              <button
                key={t}
                className={`clinic-tab-btn${activeTab === t ? " active" : ""}`}
                onClick={() => setActiveTab(t)}
              >
                {t}
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* ── Main Content ── */}
      <section className="clinic-main-section">
        <div className="container">
          <div className="clinic-layout">

            {/* ── Left column ── */}
            <div>

              {/* Overview */}
              {activeTab === "Overview" && (
                <div className="clinic-card">
                  <h3 className="clinic-card-title">About the Clinic</h3>
                  <p className="clinic-card-desc">
                    {clinic?.desc || "No description available."}
                  </p>
                </div>
              )}

              {/* Doctors — shown on both Overview & Doctors tabs */}
              {(activeTab === "Doctors" || activeTab === "Overview") && (
                <div>
                  <div className="clinic-card">
                    <div className="clinic-doctors-header">
                      <h3 className="clinic-card-title clinic-card-title--no-border">
                        {activeTab === "Overview" ? "Our Doctors" : "All Doctors"}
                      </h3>
                      <Link to="/doctor-list-page" className="clinic-view-all-link">
                        View All →
                      </Link>

                    </div>
                    <div className="clinic-doctor-grid">
                      {clinic?.doctors?.length > 0 ? (
                        clinic.doctors.map((doctor) => (
                          <div key={doctor.id} className="clinic-doctor-card">

                            {/* Card top */}
                            <div className="clinic-doctor-card-top">
                              <div className="clinic-doctor-img-wrap">
                                <Link to={`/doctordetails/${doctor.slug}`}>
                                  <img
                                    src={
                                      doctor.images
                                        ? `${API_BASE_URL}public/doctorimages/${doctor.images.split(",")[0]}`
                                        : `${API_BASE_URL}public/noimage.jpg`
                                    }
                                    alt={doctor.name}
                                    className="clinic-doctor-img"
                                  />
                                </Link>
                                <div className="clinic-doctor-verify-badge">
                                  <i className="fa-solid fa-check" />
                                </div>
                              </div>

                              <div className="clinic-doctor-meta">
                                <Link
                                  to={`/doctordetails/${doctor.slug}`}
                                  className="clinic-doctor-name"
                                >
                                  {doctor?.name}
                                </Link>
                                <p className="clinic-doctor-spec">
                                  {doctor?.department_title?.name}
                                </p>
                                <StarRow score={4.5} />
                                <div className="clinic-doctor-views">
                                  <i className="fa-solid fa-chart-line" />
                                  4,138 views
                                </div>
                              </div>
                            </div>

                            {/* Card body */}
                            <div className="clinic-doctor-card-body">
                              {doctor?.specializations && (
                                <div className="clinic-doctor-pills">
                                  {doctor.specializations
                                    .split(",")
                                    .slice(0, 3)
                                    .map((s, i) => (
                                      <span key={i} className="clinic-pill">
                                        {s.trim()}
                                      </span>
                                    ))}
                                </div>
                              )}

                              <p className="clinic-doctor-desc">{doctor?.short_desc}</p>

                              <div className="clinic-doctor-tags">
                                {doctor?.experience && (
                                  <span>
                                    <i className="fa-solid fa-briefcase" />
                                    {doctor.experience}
                                  </span>
                                )}
                                <span className="clinic-degree-tag">B.A.MS & M.S.</span>
                              </div>
                            </div>

                            {/* Card footer */}
                            <div className="clinic-doctor-card-footer">
                              <Link
                                to={`/doctordetails/${doctor.slug}`}
                                className="dc-book-btn"
                              >
                                <span>Book Consultation</span>
                              </Link>

                              <div className="clinic-fee-tag">
                                {doctor?.videocall_price == 0 ? (
                                  <span className="clinic-fee-amount clinic-fee-amount--free">
                                    Free
                                  </span>
                                ) : (
                                  <>
                                    <span className="clinic-fee-amount">
                                      ₹ {doctor?.videocall_price}
                                    </span>
                                    Consult fee
                                  </>
                                )}
                              </div>
                            </div>

                          </div>
                        ))
                      ) : (
                        <p className="clinic-empty-msg">No doctors listed.</p>
                      )}
                    </div>
                  </div>


                </div>
              )}

              {/* Services placeholder */}
              {activeTab === "Services" && (
                <div className="clinic-card">
                  <h3 className="clinic-card-title">Services Offered</h3>
                  <p className="clinic-card-desc">Services information coming soon.</p>
                </div>
              )}

              {/* Reviews placeholder */}
              {activeTab === "Reviews" && (
                <div className="clinic-card">
                  <h3 className="clinic-card-title">Patient Reviews</h3>
                  <p className="clinic-card-desc">Reviews coming soon.</p>
                </div>
              )}
            </div>

            {/* ── Sidebar ── */}
            <aside className="clinic-sidebar">

              {/* Clinic info */}
              <div className="clinic-side-card">
                <h4 className="clinic-side-title">Clinic Information</h4>

                <div className="clinic-info-row">
                  <div className="clinic-info-icon">
                    <i className="fa-solid fa-location-dot" />
                  </div>
                  <div>
                    <div className="clinic-info-label">Address</div>
                    <div className="clinic-info-value">{clinic?.address || "—"}
                      {clinic?.address ? (
                                <>
                                  <a className="direction d-inline-block ms-2" href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(clinic.address || "")}`}
                                    target="_blank" rel="noopener noreferrer">
                                    <i className="fa-solid fa-location-arrow"></i> Get Directions
                                  </a>
                                </>
                              ) : (
                                <>

                                </>
                              )}
                    </div>
                  </div>
                </div>

                <div className="clinic-info-row">
                  <div className="clinic-info-icon">
                    <i className="fa-solid fa-clock" />
                  </div>
                  <div>
                    <div className="clinic-info-label">Timings</div>
                    <div className="clinic-info-value">Mon – Sat: 9AM – 8PM</div>
                  </div>
                </div>

                <div className="clinic-info-row">
                  <div className="clinic-info-icon">
                    <i className="fa-solid fa-user-doctor" />
                  </div>
                  <div>
                    <div className="clinic-info-label">Doctors</div>
                    <div className="clinic-info-value">
                      {clinic?.doctors?.length || 0} Available
                    </div>
                  </div>
                </div>
              </div>

              {/* Booking CTA card */}
              <div className="clinic-side-card clinic-side-card--cta">
                <p>Book your appointment today</p>
                {/* <button className="clinic-btn-book">
                  <i className="fa-solid fa-calendar-check" />
                  Book Appointment
                </button> */}
               <a href={`tel:${clinic?.mobile || ""}`} className="clinic-btn-call">
    <i className="fa-solid fa-phone" />
    Call Now
  </a>
              </div>

            </aside>
          </div>
        </div>
      </section>



      <Footer />
    </div>
  );
};

export default FrontClinicDetails;